"use client";

export default function Error({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="min-h-screen flex items-center justify-center">
      <div className="text-center px-4">
        <h1 className="text-4xl font-bold text-gray-300">Klaida</h1>
        <p className="mt-4 text-gray-600">
          Atsiprašome, įvyko nenumatyta klaida. Bandykite dar kartą.
        </p>
        <button
          onClick={reset}
          className="mt-6 inline-flex items-center px-5 py-2.5 rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700 transition-colors"
        >
          Bandyti dar kartą
        </button>
      </div>
    </main>
  );
}
